import React, { lazy, Suspense } from 'react'
import Loader from 'components/Reusable/Loader'

const Menu = lazy(() => import('components/Sections/Menu'))
const Footer = lazy(() => import('components/Layout/Footer'))

function MenuPage() {
    const loader = () => <Loader />

    const MainComponent = () => (
        <Suspense fallback={loader()}>
            <Menu />
            <Footer />
        </Suspense>
    )

    return MainComponent()
}

export default MenuPage